import useConnect from "./connect"
import WithLoader from "~/ui-rtk/components/layout/WithLoader/WithLoader"
import useReconnectSourcesBanner from "~/ui-rtk/hooks/reconnect-sources-banner"
import { useEffect } from "react"
import ReconnectBanner from "~/ui-rtk/components/layout/ReconnectBanner/ReconnectBanner"
import PaidWeightModel from "~/ui-rtk/components/features/dashboards/PaidMediaWeighting/PaidWeightModel"

export default function PageBrandMediaOptimization() {
  const { content, isLoading, requiredSources } = useConnect()

  const { connectorsToReconnect, setRequiredSources } =
    useReconnectSourcesBanner()

  useEffect(() => {
    setRequiredSources(requiredSources)
  }, [requiredSources])

  return (
    <WithLoader isLoading={isLoading}>
      <ReconnectBanner connectors={connectorsToReconnect} />
      <PaidWeightModel
        title={content.content.title}
        slug={content.slug}
        parent={content.parent}
        items={content.content.items}
        periodPicker={content.content.periodPicker}
      />
    </WithLoader>
  )
}
